import { render, staticRenderFns } from "./club-icon.vue?vue&type=template&id=2e812aa6&"
import script from "./club-icon.ts?vue&type=script&lang=ts&"
export * from "./club-icon.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports